export default {
  convertToNumber: (appVersion: string): number => Number(appVersion.replace(/\./g, '')),

  isOlder: (appVersion: string, compareVersion: number): boolean => {
    const appVersionNum = Number(appVersion.replace(/\./g, ''))
    return appVersionNum < compareVersion
  },
}
